import { useContext } from "react";
import { Breadcrumb } from "react-bootstrap";
import { Link } from "react-router-dom";

import { RouteContext } from "../../contexts/routeContext";
import { SiteContext } from "../../contexts/siteContext";
import { UserDataContext } from "../../contexts/userDataContext";
import { orgPath, sitePath } from "../../utils";
import { Pill } from "../pill";

const SiteBreadcrumb = () => {
	const {
		selectedSite: { id, name },
	} = useContext(SiteContext);
	const { selectedOrg } = useContext(UserDataContext);

	return (
		<Breadcrumb.Item
			key={`bread-index-${id}`}
			linkAs={Link}
			linkProps={{ to: sitePath(selectedOrg?.id, id) }}
		>
			<Pill className="mt-0" variant="primary" text={name}></Pill>
		</Breadcrumb.Item>
	);
};

export const TopCrumb = () => {
	const { route } = useContext(RouteContext);
	const { selectedOrg } = useContext(UserDataContext);
	const {
		selectedSite: { id: siteId },
	} = useContext(SiteContext);

	return (
		<Breadcrumb
			listProps={{
				className:
					"breadcrumb-charcoal breadcrumb-text-light text-white ms-3 py-0 mb-0",
			}}
		>
			<Breadcrumb.Item
				key={`bread-index-dash`}
				linkAs={Link}
				linkProps={{ to: orgPath(selectedOrg?.id, "/") }}
			>
				{selectedOrg.name}
			</Breadcrumb.Item>
			{route.isSitePage ? <SiteBreadcrumb /> : null}
			{route.breadcrumbs
				? route.breadcrumbs.map((crumbRoute, key) => (
						<Breadcrumb.Item
							key={`bread-index-${key}`}
							linkAs={Link}
							linkProps={{
								to: crumbRoute.isSitePage
									? sitePath(
											selectedOrg?.id,
											siteId,
											crumbRoute.path
									  )
									: orgPath(selectedOrg?.id, crumbRoute.path),
							}}
						>
							{crumbRoute.title}
						</Breadcrumb.Item>
				  ))
				: null}
			<Breadcrumb.Item active>{route.title}</Breadcrumb.Item>
		</Breadcrumb>
	);
};
